import {
  LOAD_UP_NEXT_ERROR,
  LOAD_UP_NEXT_REQUEST,
  LOAD_UP_NEXT_SUCCESS,
} from 'modules/loaders/load-up-next';
import { createReducer } from 'util/reducers';

// Reducer
export interface UiUpNextState {
  loading: boolean;
}

const initialState: UiUpNextState = {
  loading: false,
};

export default createReducer(initialState, {
  [LOAD_UP_NEXT_REQUEST](state) {
    return {
      ...state,
      loading: true,
    };
  },

  [LOAD_UP_NEXT_SUCCESS](state) {
    return {
      ...state,
      loading: false,
    };
  },

  [LOAD_UP_NEXT_ERROR](state) {
    return {
      ...state,
      loading: false,
    };
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/up-next.ts